import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ProgressBar } from './Step1';
import { MessageCircle } from 'lucide-react';

const platforms = [
  { id: 'telegram', name: 'Telegram', color: '#229ED9' },
  { id: 'discord', name: 'Discord', color: '#5865F2' },
  { id: 'whatsapp', name: 'WhatsApp', color: '#25D366' },
  { id: 'slack', name: 'Slack', color: '#E01E5A' },
];

export default function OnboardingStep3() {
  const [selected, setSelected] = useState([]);
  const navigate = useNavigate();

  const toggle = (id) => {
    setSelected(prev => prev.includes(id) ? prev.filter(s => s !== id) : [...prev, id]);
  };

  return (
    <div className="min-h-screen bg-[#050505] flex items-center justify-center px-4 py-20">
      <div className="w-full max-w-2xl">
        <ProgressBar step={3} />
        <h1 data-testid="onboarding-step3-title" className="text-2xl md:text-3xl font-bold text-white font-mono mb-2 section-marker">Connect messaging</h1>
        <p className="text-zinc-500 text-sm mb-8">Choose which platforms your agent will use. You can change this later.</p>

        <div className="grid grid-cols-2 gap-4 mb-8">
          {platforms.map(p => (
            <button
              key={p.id}
              data-testid={`onboarding-platform-${p.id}`}
              onClick={() => toggle(p.id)}
              className={`text-left p-6 border rounded-sm transition-all flex items-center gap-4 ${selected.includes(p.id) ? 'bg-emerald-500/5 border-emerald-500/30' : 'bg-[#0A0A0A] border-zinc-800 hover:border-zinc-700'}`}
            >
              <div className="w-10 h-10 rounded-sm flex items-center justify-center" style={{ backgroundColor: `${p.color}20` }}>
                <MessageCircle size={20} style={{ color: p.color }} />
              </div>
              <div>
                <h3 className="text-white font-mono font-bold text-sm">{p.name}</h3>
                <p className="text-zinc-600 text-xs font-mono">{selected.includes(p.id) ? 'Selected' : 'Click to select'}</p>
              </div>
            </button>
          ))}
        </div>

        <button
          data-testid="onboarding-configure-later"
          onClick={() => navigate('/onboarding/step-4')}
          className="w-full text-center text-sm font-mono text-zinc-500 hover:text-zinc-300 py-3 border border-zinc-800 rounded-sm hover:border-zinc-700 transition-all mb-8"
        >
          Will configure later
        </button>

        <div className="flex items-center justify-between">
          <button data-testid="onboarding-back-3" onClick={() => navigate('/onboarding/step-2')} className="text-sm font-mono text-zinc-500 hover:text-zinc-300 transition-colors">Back</button>
          <button data-testid="onboarding-next-3" onClick={() => navigate('/onboarding/step-4')} className="bg-emerald-500 text-black font-mono font-bold text-sm rounded-sm px-8 py-3 hover:bg-emerald-400 transition-all click-scale shadow-[0_0_15px_rgba(16,185,129,0.3)]">
            Continue
          </button>
        </div>
      </div>
    </div>
  );
}
